<template>
  <div>
    <v-carousel
      v-if="!$vuetify.breakpoint.xsOnly"
      cycle
      height="222"
      :hide-delimiters="true"
      :show-arrows="false"
      v-model="active"
      interval="4000"
    >
      <v-carousel-item v-for="(image, index) in images" :key="index">
        <v-img
          :src="image.src"
          :lazy-src="image.src"
          @click="image.onClick"
          class="carousel-image"
        ></v-img>
      </v-carousel-item>
    </v-carousel>
    <v-carousel
      v-else
      cycle
      height="100"
      :hide-delimiters="true"
      :show-arrows="false"
      v-model="active"
      interval="4000"
    >
      <v-carousel-item v-for="(image, index) in MobileImages" :key="index">
        <v-img
          :src="image.src"
          :lazy-src="image.src"
          @click="image.onClick"
          class="carousel-image"
        ></v-img>
      </v-carousel-item>
    </v-carousel>
    <div class="dot-container" v-if="!$vuetify.breakpoint.xsOnly">
      <div
        v-for="(image, index) in images"
        :key="'dot-' + index"
        icon
        @click="setActive(index)"
        class="dot-btn"
      >
        <v-icon
          :color="active === index ? 'primary' : '#d2d2d2'"
          class="dot-icon ml-2"
          small
          >mdi-circle</v-icon
        >
      </div>
    </div>
    <div class="dot-container" v-else>
      <div
        v-for="(image, index) in images"
        :key="'dot-' + index"
        icon
        @click="setActive(index)"
        class="dot-btn"
      >
        <v-icon
          :color="active === index ? 'primary' : '#d2d2d2'"
          class="dot-icon"
          >mdi-circle-small</v-icon
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerCarousel",
  data() {
    return {
      active: 0, // For controlling active carousel item
      images: [
        {
          src: require("@/assets/images/banners/PremiumGroupsDesktop.png"),
          onClick: () => this.$router.push({ name: "premiumGroups" }),
        },
        {
          src: require("@/assets/images/banners/PortfolioReviewDesktop.png"),
          onClick: () => this.$router.push({ name: "tradingSection" }),
        },
        {
          src: require("@/assets/images/banners/WebinarDesktop.png"),
          onClick: () => this.$router.push({ name: "WebinarsPage" }),
        },
        {
          src: require("@/assets/images/banners/ResearchReportDesktop.png"),
          onClick: () => this.$router.push({ name: "mainPage" }),
        },
        {
          src: require("@/assets/images/banners/CoursesDesktop.png"),
          onClick: () => window.open("https://courses.covesto.in/", "_blank"),
        },
      ],
      MobileImages: [
        {
          src: require("@/assets/images/banners/PremiumGroupsDesktop.png"),
          onClick: () => this.$router.push({ name: "premiumGroups" }),
        },
        {
          src: require("@/assets/images/banners/PortfolioReviewDesktop.png"),
          onClick: () => this.$router.push({ name: "tradingSection" }),
        },
        {
          src: require("@/assets/images/banners/WebinarDesktop.png"),
          onClick: () => this.$router.push({ name: "WebinarsPage" }),
        },
        {
          src: require("@/assets/images/banners/ResearchReportDesktop.png"),
          onClick: () => this.$router.push({ name: "mainPage" }),
        },
        {
          src: require("@/assets/images/banners/CoursesDesktop.png"),
          onClick: () => window.open("https://courses.covesto.in/", "_blank"),
        },
      ],
    };
  },
  methods: {
    setActive(index) {
      this.active = index;
    },
  },
};
</script>

<style scoped>
.dot-container {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}
.carousel-image {
  cursor: pointer;
}
.dot-btn {
  margin: 0 0; /* Adjust the margin to decrease the gap */
  padding: 0; /* Remove padding for tighter spacing */
}
.dot-icon {
  margin: 0;
  padding: 0;
}
</style>
